// src/pages/jobs/JobsPage.jsx

import React, { useState } from "react";

import BreadCrumbArea from "../../layouts/BreadCrumbArea";
import JobCard from "./JobCard";
import JobDetails from "./JobDetails";
import jobsData from "./jobsData";
import useTitle from "../../hooks/useTitle";

const JobsPage = () => {
  useTitle("Jobs");

  const [program, setProgram] = useState("ALL");
  const [search, setSearch] = useState("");
  const [selectedJob, setSelectedJob] = useState(null);

  const programs = ["ALL", ...new Set(jobsData.map((j) => j.program))];

  const filteredJobs = jobsData.filter(
    (j) =>
      (program === "ALL" || j.program === program) && j.title.includes(search)
  );

  return (
    <>
      <BreadCrumbArea
        title="Jobs"
        subTitle="Human Resources"
        image="url(/assets/img/bg/breadcrumb-2.jpg)"
      />

      <div className="pt-120 pb-90" dir="rtl">
        <div className="container">
          {!selectedJob && (
            <>
              <div className="text-center mb-40">
                <h2>بست های کادری پوهنتون میوند</h2>
                <p>تاریخ ثبت نام: ۱۴۰۴/۱۰/۱۶ الی ۱۴۰۴/۱۰/۲۶</p>
              </div>

              <div className="row mb-30">
                <div className="col-lg-4 mb-3 mb-lg-0">
                  <input
                    className="form-control"
                    placeholder="جستجو عنوان بست"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <div className="col-lg-4 mb-3 mb-lg-0">
                  <select
                    className="form-control"
                    value={program}
                    onChange={(e) => setProgram(e.target.value)}
                  >
                    {programs.map((p) => (
                      <option key={p} value={p}>
                        {p === "ALL" ? "همه پوهنځی‌ها" : p}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-4">
                  <a
                    href="/cv-builder"
                    className="btn ss-btn w-100 d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "15px",
                      height: "40px",
                      padding: "0",
                    }}
                  >
                    ساختن CV
                  </a>
                </div>
              </div>

              <div className="row">
                {filteredJobs.map((job) => (
                  <div key={job.id} className="col-lg-4 col-md-6 mb-30">
                    <JobCard job={job} onSelect={setSelectedJob} />
                  </div>
                ))}
              </div>
            </>
          )}

          {selectedJob && (
            <JobDetails job={selectedJob} onBack={() => setSelectedJob(null)} />
          )}
        </div>
      </div>
    </>
  );
};

export default JobsPage;
